(function () {
  'use strict';

  /* @ngdoc object
   * @name maleFemaleDiscrepancy
   * @description
   *
   */
  angular
    .module('maleFemaleDiscrepancy', [
      'ui.router'
    ]);
}());
